import {
	createFileRoute,
	redirect,
	useRouteContext,
} from "@tanstack/react-router";
import { ListingsPage } from "@/app/partner/pages/listings";
import { WhitelabelListingsPage } from "@/app/partner/pages/listings/whitelabel";
import { canAccessRoute, hasNavbarAccess } from "@/lib/auth";

function ListingsRouteComponent() {
	const { partner } = useRouteContext({ from: "__root__" });
	const isWhitelabel = hasNavbarAccess(partner, "white_label_listings");

	if (isWhitelabel) {
		return <WhitelabelListingsPage />;
	}
	return <ListingsPage />;
}

export const Route = createFileRoute("/flex/dashboard/listings")({
	beforeLoad: async ({ context }) => {
		const { partner } = context;
		const access = canAccessRoute(partner, "listings");

		if (!access.allowed) {
			throw redirect({ to: "/flex/dashboard" });
		}
	},
	component: ListingsRouteComponent,
});
